import TechAccountSetupApp from "./TechAccountSetupApp.vue";
import { vueApp } from "../Common/vueApp";

export default vueApp(TechAccountSetupApp);
